import { Serializable } from '../../core/models/serializable';
export class ProviderWebsiteModel
  implements Serializable<ProviderWebsiteModel>
{
  fromObject(obj: any): ProviderWebsiteModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    return {
      ProviderWebsiteId: this.providerWebsiteId,
      IndexNumber: this.indexNumber,
      Name: this.name,
      DisplayName: this.displayName,
      IsExternal: this.isExternal,
      Url: this.url,
      LogoFileName: this.logoFileName,
      IsActive: this.isActive,
      CreateDate: this.createDate,
      IsAnnoucementProvider: this.isAnnoucementProvider,
      IsCvProvider: this.isCvProvider,
      IsMain: this.isMain,
    };
  }

  public providerWebsiteId: number;
  public indexNumber: number;
  public name: string;
  public displayName: string;
  public isExternal: boolean;
  public url: string;
  public logoFileName: string;
  public isActive: boolean;
  public createDate: Date;
  public isAnnoucementProvider: boolean;
  public isCvProvider: boolean;
  public isMain: boolean;
}
